// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2dtEs","fileBtn":"File_fileBtn__3QhK1","closeBtn":"File_closeBtn__3QKP9","fileSelected":"File_fileSelected___pTnh","disabled":"File_disabled__42-oz"};